import { isEqual } from 'lodash'
import { getStateValue } from './states'

const classNameMap = {
    visa: 'visa',
    'american express': 'american-express',
    americanexpress: 'american-express',
    mastercard: 'mastercard',
    'debit-iterac': 'iterac',
    debit: 'debit',
    amex: 'american-express',
}

const creditCardShortCodes = {
    visa: 'VISA',
    'american express': 'AM',
    americanexpress: 'AM',
    mastercard: 'MC',
    'debit-iterac': 'IR',
    debit: 'DE',
    amex: 'AM',
}

export const getCreditCardShortCode = cardType =>
    cardType && creditCardShortCodes[cardType.toLowerCase()] ? creditCardShortCodes[cardType.toLowerCase()] : 'card'

export const getCreditCardType = cardType =>
    cardType && classNameMap[cardType.toLowerCase()] ? classNameMap[cardType.toLowerCase()] : 'card'

export const getPaymentType = paymentType =>
    paymentType === 'phone' || paymentType === 'cash' ? paymentType : getCreditCardType(paymentType)

export const getCreditCardNumberPreview = ({ nickName, cardLast4, expDate }) =>
    `${nickName} **** ${cardLast4.slice(-4)} ${expDate.match(/.{1,2}/g).join('/')}`

export const getPadNumberPreview = ({ achAccountNumber }) =>
    `PAD **** ${achAccountNumber && achAccountNumber.slice(-4)}`

export const objectsEqual = (objects, exclusions = []) => {
    const updatedObjects = objects.map(obj => {
        exclusions.forEach(exl => {
            if (obj && exl in obj) {
                delete obj[exl]
            }
        })

        return obj
    })

    return updatedObjects.reduce((a, b) => isEqual(a, b))
}

// TODO refactor formattter to use only one
export const invoicePriceFormatter = amount => `$ ${parseFloat(amount).toFixed(2)}`

export const priceFormatter = ({ currencySymbol, price }) => `${currencySymbol}${parseFloat(price).toFixed(2)}`

export const isAddressFilled = (address = {}) => {
    const { address1, postalCode, city, country, state } = address || {}

    if ([!address1, !postalCode, !city, !country, !state].includes(true)) {
        return false
    }

    return true
}

export const formatAddress = (address = {}) => {
    const { address1, address2, postalCode, city, country, state } = address
    const stateName = getStateValue(country)(state)

    const stateNameFormated = stateName ? `${stateName.label}, ` : ''
    const address2Formated = address2 ? `${address2}, ` : ''

    return `${address1}, ${address2Formated}${postalCode}, ${city}, ${stateNameFormated}${country}`
}

export const isExternalUrl = (url = '') => /^https?:\/\/.+$/.test(url)
